import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="booth"
export default class extends Controller {
  static targets = ["searchInput", "loader", "wildCardForm", "wildCardInput", "wildCardFilter", "reset", "all", "performers", "volunteers", "vendors", "willcalls"]

  initialize(){
      console.log('booth connected')
      //reset window when turbo-stream is rendered
      document.addEventListener('turbo:before-stream-render', event => {
        //scrolls to top
        this.resetWindow()
      });
  
    }

    connect(){
      const url = new URL(location);
      const active = url.searchParams.get("filter")
      this.setSegmentColor(active)
    }
  

  
  loader(event){
    this.wildCardFilterTarget.value = event.params.filter
    this.clearSearch()
    this.clearWildCard()
    this.loaderTarget.classList.remove("d-none");
    document.getElementById('participants').style.display = "none";
  }

  updateUrl(event){
  const url = new URL(location);
  url.searchParams.set("participant_id", event.params.participant);
  history.pushState({}, "", url);

  }

  clearSearch(){
    this.searchInputTarget.value = ''
  }

  clearWildCard(){
    this.wildCardInputTarget.value = ''
    this.wildCardInputTarget.style.backgroundColor = ''
  }

  highlightWildcard(){
    this.wildCardInputTarget.style.backgroundColor = 'yellow';
  }

  quickSearch() {
    
    var filter = this.searchInputTarget.value.toUpperCase()
    let names = document.querySelectorAll('.list-group-item')
   
    let i = 0
    let visCount = 0
    while (i < names.length){
     var name = names[i].textContent.toUpperCase()
     if (name.includes(filter) ) { // && visCount < 10
      names[i].style.display = "";
      visCount++
     }
     else {
      names[i].style.display = "none";
     }
      i++
    }
  }

  resetWindow(){
    //scroll to stop and remove any modals
    window.scrollTo(0, 0) 
    var dismissBtn = document.querySelectorAll('.dismiss-summary-modal')
    dismissBtn.forEach(btn => {
      if (btn){
        btn.click()
        }
    } )
  }

  setSegmentColor(event){
    let active
    const segments = ["all", "performers", "volunteers", "vendors", "willcalls"]
    console.log(event)
    console.log(typeof event)

    if (!event){
      active = "all"
    }else if (typeof event == "string"){
      active = event
    }else{
      active =  event.params.filter
    }
  
    segments.forEach(option =>{
      if (active == option ){
        document.getElementById(active + "-button").classList.add("btn-solid-" + active)
        document.getElementById(active + "-button").classList.remove("btn-outline-" + active)

      }
      else
      {
        document.getElementById(option + "-button").classList.remove("btn-solid-" + option)
        document.getElementById(option + "-button").classList.add("btn-outline-" + option)

      }
    })
  }
}
